import axios from "axios";
import { useQuery } from "react-query";

export const  useGetWorkbenchData = ({body,config}) =>  {
    return useQuery({
      queryKey: ['workbench', body.report, body.role],
      queryFn: () => {
        return axios
    .post(`${process.env.REACT_APP_API_URI}CaseAssignmentWorkbenchGridbind`, body,config)
    .then((res) => {
      if(res.data.error != null || res.data.error != undefined){
        throw new Error(res.data.message);
      }
      return res.data;
    });
      },
      refetchOnWindowFocus: false,
    });
  }
